module.exports = __webpack_public_path__ + "static/media/2.384f3723.svg";